import { Component, OnInit, SecurityContext } from "@angular/core";
import { PropertiesService } from "src/app/services/properties.service";
import { LanguagesService } from "src/app/services/languages.service";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { displayOperation } from "src/app/utilities/utilities";
import { UsersService } from "src/app/services/user.service";
import { Profilo } from "src/app/interfaces/user";
import { Router } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styles: ['h1 { color: white; }',
    'p { color: ghostwhite; }',
    'div { text-align: center; }',
    'a.disabledLink { pointer-events: none; cursor: default; }',
    '.container { min-height: 75vh; position: relative;}',
    '.wrap {padding-bottom: 5.5rem;}',
    'div.helpAddress { position: absolute; bottom: 0; width: 100%; height: 2.5rem;}',
    'span {  display: inline; }',
    'fa-icon { color: white; }',]
})

export class HomePageComponent implements OnInit {

  authLinkMsg = "";
  resetPswMsg = "";
  changePswMsg = "";
  helpAddress = "";
  registrationMsg = "";
  faEnvelope = faEnvelope;
  profilo: Profilo;
  testo_HP_linea1 = this.languageService.getValue("testo_HP_linea1");
  testo_HP_linea2 = this.languageService.getValue("testo_HP_linea2");


  constructor(private propertiesService: PropertiesService,
    private userService: UsersService,
    private languageService: LanguagesService,
    private router : Router,
    private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.helpAddress = this.getAddress();
    this.authLinkMsg = this.getWebSiteUrl('homepage_auth_link');
    this.resetPswMsg =  this.getResetPswUrl('homepage_reset_psw_link');
    this.changePswMsg = this.getChangePswUrl('homepage_change_psw_link');
    this.profilo = this.userService.currentUser.value;
  }


  getMessage(etichetta, link, isExternalLink){
    let result = this.languageService.getValue(etichetta);
    result = result != null && result != undefined ?  result.replace("##link", `<a href="${link}" ${isExternalLink ? "target='_blank'" : ""}><strong class="link">${this.languageService.getValue('here_link')}</strong></a>`) : "";
    return this.sanitizer.sanitize(SecurityContext.HTML, result);
  }

  getWebSiteUrl(etichetta): string {
    let link = this.propertiesService.getProp('authApiPrefix') + `/#/`;
    return this.getMessage(etichetta, link, false);
  }

  getResetPswUrl(etichetta): string {
    let link = this.propertiesService.getProp('pswManagementPrefix') + `/Reset`;
    return this.getMessage(etichetta, link, true);
  }

  getChangePswUrl(etichetta): string {
    let link = this.propertiesService.getProp('pswManagementPrefix') + `/Change`;
    return this.getMessage(etichetta, link, true);
  }

  getAddress(){
    let address = this.propertiesService.getProp('helpAddress');
    return address;
  }

  showRecordCompanyWithRLRegistrationPage() : boolean {
		return displayOperation(['GetValidationsFromAuthConf', 'GetNationsFromAuthConf', 'GetDocumentTypesFromAuthConf', 'RecordCompanyUserRegistration'], this.profilo.Funzionalita);
  }
  
  showLRegistrationPage() : boolean {
    return displayOperation(['GetValidationsFromAuthConf', 'GetNationsFromAuthConf', 'GetDocumentTypesFromAuthConf', 'ExternalUserRegistration'], this.profilo.Funzionalita);
	}

  goToRegistrationPage(){
    this.router.navigate(['record-company-user-registration']);
  }
}
